module.exports = __webpack_public_path__ + "img/cover-minigame-bg.f8fdbfc2.png";